// Generate 15-minute time slots for pharmacy hours
// Morning session: 10:00 AM - 1:00 PM
// Afternoon session: 2:00 PM - 5:00 PM

export function generateTimeSlots() {
  const slots = []

  // Morning session: 10:00 AM - 1:00 PM (10:00, 10:15, 10:30, 10:45, ...)
  const morningSlots = generateSessionSlots(10, 0, 13, 0)
  slots.push(...morningSlots)

  // Afternoon session: 2:00 PM - 5:00 PM (14:00, 14:15, 14:30, 14:45, ...)
  const afternoonSlots = generateSessionSlots(14, 0, 17, 0)
  slots.push(...afternoonSlots)

  return slots
}

// Helper function to generate slots for a specific time range
function generateSessionSlots(startHour, startMinute, endHour, endMinute) {
  const slots = []
  let currentHour = startHour
  let currentMinute = startMinute

  while (currentHour < endHour || (currentHour === endHour && currentMinute < endMinute)) {
    const timeString = `${String(currentHour).padStart(2, '0')}:${String(currentMinute).padStart(2, '0')}`
    const displayTime = formatTimeDisplay(currentHour, currentMinute)

    slots.push({
      value: timeString,
      label: displayTime
    })

    // Add 15 minutes
    currentMinute += 15
    if (currentMinute >= 60) {
      currentMinute = 0
      currentHour += 1
    }
  }

  return slots
}

// Format time for display (e.g., "09:00 AM", "02:30 PM")
export function formatTimeDisplay(hour, minute) {
  const period = hour >= 12 ? 'PM' : 'AM'
  const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour
  return `${displayHour}:${String(minute).padStart(2, '0')} ${period}`
}

// Parse time string (HH:MM) to display format
export function parseTimeToDisplay(timeString) {
  if (!timeString) return ''
  const [hour, minute] = timeString.split(':').map(Number)
  return formatTimeDisplay(hour, minute)
}

// Filter out booked time slots
export function getAvailableSlots(allSlots, bookedSlots) {
  const bookedTimes = new Set(bookedSlots.map(slot => slot.preferred_time))
  return allSlots.filter(slot => !bookedTimes.has(slot.value))
}

// Format date to YYYY-MM-DD in local timezone (avoids UTC conversion shifting dates)
export function formatLocalDate(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
